export default __webpack_public_path__ + "static/post-imza-14e94b03885e59b6b634cf07221c5b4f.svg";